
















































































































































import { Component, Watch } from 'vue-property-decorator';

import { ComponenteBase } from '@/views/base/ComponenteBase';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import { StateParam } from './models/NDVModalTabs.model';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

import {
  PermisoAccion,
  codigoAccionesMenuItem as allActions,
} from '@/views/base/VariablesPermisos';
import store from '@/store';
import { actionsEvent } from '@/setup';
import MenuItem from '@/components/MenuItem.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Confirmation from '@/components/Confirmation.vue';

import { fetchNDV } from './fetchNDV';
import { getUserId } from '../MantenedorLocalidad/helpers/getUserId';
import NDVModalTabs from './NVDModalTabs.vue';
import PopUpGeneratedReports from './PopUpGeneratedReoports.vue';
import {
  ParamsApi,
  DataApi,
  FilterApi,
  FunctionParams,
  ContextMsg,
  ParamsAttention,
} from './models/NDVBase.model';
import NVDModalEnvioReservations from './NVDModalEnvioReservations.vue';
@Component({
  components: {
    GridComponent: AgGridVue,
    FormFieldsContainer,
    DatePicker,
    NDVModalTabs,
    PopUpGeneratedReports,
    MenuItem,
    Confirmation,
    NVDModalEnvioReservations,
  },
})
export default class NDVBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.NDV;

  verDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };
  generarAtencion: PermisoAccion = {
    accionCodigo: 121,
    visible: false,
  };
  accionReutilizable: PermisoAccion = {
    accionCodigo: 122,
    visible: false,
  };
  readonly accionesTotales: PermisoAccion[] = [
    this.verDetalle,
    this.generarAtencion,
  ];
  readonly loadingService = new LoadingService();
  readonly codigoAccionesMenuItem = Object.values(allActions);

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  dataList: DataApi[] = [];
  now: string = moment().format('YYYY-MM-DD');
  showModalEnvio: boolean = false;
  acitvateChange: boolean = false;
  showPopUpReport: boolean = false;
  timeout: { timeout: number } = { timeout: 3000 };

  msgReport: string = '';

  filter: FilterApi = {};
  objectParam: ParamsApi = {
    start_date: moment().subtract(1, 'months'),
    end_date: moment(),
    ndvcliente_rut: '',
    ndvnombre: '',
    ndvtipo_venta: '',
    ndvestado_conecta: '',
    ndvpor_reservar: '',
  };

  showModalViewDetail: boolean = false;
  data: DataApi = {};
  tipo_emision: string = 'atencion';
  dialogPopUp: boolean = false;
  contextPopUp: ContextMsg = {};
  confirmations: number = 0;

  constructor() {
    super();
    this.columnDefs = this.colsGrid({
      fn: this.funcionalidad,
      allActions: this.codigoAccionesMenuItem,
    });
    this.addActionsEvent();
    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }
  addActionsEvent() {
    actionsEvent.onVerDetalle(this.handleViewDetail);
    actionsEvent.onGenerarAtencion(this.handleGenerateAttention);
    actionsEvent.onAccionReutilizable(this.handleViewAnnulment);
    actionsEvent.onFacturacionEspecial(this.handleFacturacionManual);
    actionsEvent.onActualizarNDV(this.handleActualizarNDV);
  }
  colsGrid({ fn, allActions }: FunctionParams): ColDef[] {
    const colsId = [
      'Nombre NDV',
      'Orden de Compra',
      'Razón Social Cliente',
      'RUT Cliente',
      'Fecha de Creación',
      'Divisa',
      'Lista de Precios',
      'Modalidad',
      'Tipo de Venta',
      'Razón Social Mandante',
      'RUT Mandante',
      'Flota',
      'Tipo de Flota',
      'Area Respondable',
      'Ejecutivo de Venta',
      'Cantidad de Equipos',
      'Precio Importe Total',
      'CRM Estado',
      'CRM Razon del Estado',
      'Estado en Conecta',
      'Usuario Anula',
      'Fecha Anula',
      'CRM SAV',
    ];

    const cols: ColDef[] = colsId.map(col => {
      let cb = null;
      if (col === 'Estado en Conecta') {
        cb = {
          cellRenderer: (params: any) =>
            this.iconState({ state: params.data['Estado en Conecta'] }),
        };
      }

      return {
        headerName: col,
        field: col,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 220,
        minWidth: 100,
        ...cb,
      };
    });

    cols.push({
      headerName: 'Acciones',
      sortable: false,
      resizable: true,
      filter: false,
      width: 120,
      minWidth: 120,
      maxWidth: 120,
      field: 'id',
      cellRendererFramework: MenuItem,
      cellRendererParams: (params: { data: DataApi }) => ({
        funcionalidad: fn,
        codigoAccionesMenuItem: allActions,
        usuario: store.state.user,
        data: params.data,
        contextoAccionReutilizable: ['Ver Anulación', 'backspace'],
      }),
      colId: 'params',
      rowDrag: false,
      pinned: 'right',
      lockVisible: true,
      suppressMovable: true,
      suppressMenu: true,
      getQuickFilterText: () => '',
    });

    return cols;
  }

  iconState({ state }: StateParam): string {
    const val = state.toLowerCase();
    return `<i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
      val === 'ingresado' || val === 'facturado parcial'
        ? '#ffe800'
        : val === 'facturado total'
        ? 'rgb(42 255 78)'
        : 'rgb(255 58 58)'
    }"></i>
     <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${state}</a>`;
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.filter = await this.getFilters();
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.reloadGrid();
  }

  async reloadGrid(clear: boolean = false): Promise<void> {
    if (clear) await this.clear();
    this.dataList = await this.getAll();
    this.gridApi.setRowData(this.dataList);
    this.gridApi.setDomLayout('autoHeight');
  }

  @Watch('objectParam.start_date')
  startDateChange() {
    if (this.objectParam.start_date > this.objectParam.end_date) {
      this.objectParam.end_date = this.objectParam.start_date;
    }
    this.handleFilters();
  }

  @Watch('objectParam.end_date')
  endDateChange() {
    if (this.objectParam.end_date < this.objectParam.start_date) {
      this.objectParam.start_date = this.objectParam.end_date;
    }
    this.handleFilters();
  }

  handleSearchFilter(): void {
    this.acitvateChange = true;
    this.handleFilters();
  }

  handleClearFilter(): void {
    if (this.acitvateChange) {
      this.reloadGrid(true);
      return;
    }
    this.clear();
  }

  handleFilters(): void {
    if (this.acitvateChange) {
      this.reloadGrid();
    }
  }

  handleViewAnnulment(params: any) {
    //console.log('handleViewAnnulment', params.data);
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  handleClosedModal(): void {
    this.showModalEnvio = false;
    this.showModalViewDetail = false;
    this.clearDataPopUp();
    this.data = {};
    actionsEvent.removeListeners();
    this.addActionsEvent();
    this.handleSearchFilter();
  }

  handleGenerateAttention(params: { data: DataApi }): void {
    // //console.log('handleGenerateAttention', params.data);
    this.data = params.data;
    this.tipo_emision = 'atencion';
    this.showModalEnvio = true;
    // this.dialogPopUp = true;
    // this.contextPopUp = {
    //   title: 'Generar Atención',
    //   msg: `¿Está seguro que desea generar una atención para la nota de venta ${params.data['Nombre NDV']}?`,
    //   attention: params.data,
    //   btnConfirmation: 'Confirmar',
    // };
  }
  handleFacturacionManual(params: { data: DataApi }): void {
    //console.log('handleGenerateAttention', params.data);
    this.tipo_emision = 'facturacion';
    this.data = params.data;
    this.showModalEnvio = true;
  }
  async handleActualizarNDV(params: { data: DataApi }) {
    // console.log('handleActualizarNDV', params.data);
    const self = this;
    self.loadingService.showLoading();
    const data = params.data;
    const body = {
      ndvnumero: data['Nombre NDV'],
      eliminar_anterios: true,
      valida_facturacion: true,
    };
    return await fetchNDV({
      endpoint: 'obterner_ndv_crm',
      body: body,
    })
      .then(response => {
        const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA } = response.data;

        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { ...self.timeout });
        } else {
          self.$snotify.success(MENSAJE_RESPUESTA, { ...self.timeout });
        }
      })
      .catch((err: Error) => {
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw err;
      })
      .finally(() => {
        self.handleSearchFilter();
        self.loadingService.hideLoading();
      });
  }

  handleViewDetail(params: { data: DataApi }): void {
    this.data = params.data;
    this.showModalViewDetail = true;
  }

  handleShowPopUp(confirmation: boolean): void {
    if (!confirmation) return this.clearDataPopUp();
    this.confirmations++;
    this.validateSatateValue({
      confirmations: this.confirmations,
      attention: this.contextPopUp.attention,
    });
  }

  validateSatateValue({ confirmations, attention }: ParamsAttention): void {
    if (confirmations === 1) {
      this.dialogPopUp = false;
      this.contextPopUp.title = 'Aviso Importante';
      this.contextPopUp.msg =
        'Puede validar si hay atenciones vigentes para esta nota de venta en la opción Ver Detalle y debe realizar la anulación manual en INET y en la opción de Atenciones';
      this.contextPopUp.btnConfirmation = 'Continuar';
      setTimeout(() => (this.dialogPopUp = true), 800);
    }
    if (confirmations === 2) {
      this.showModalEnvio = true;
      this.data = attention;
      // this.add({ attention });
      // this.clearDataPopUp();
    }
  }

  clearDataPopUp(): void {
    this.dialogPopUp = false;
    this.confirmations = 0;
    this.contextPopUp = {};
  }

  clear(): void {
    this.showModalViewDetail = false;
    this.acitvateChange = false;
    this.objectParam = Object.fromEntries(
      Object.keys(this.objectParam).map(key => [key, ''])
    );
    this.objectParam.start_date = moment().subtract(1, 'months');
    this.objectParam.end_date = moment();
    this.data = {};
  }

  findFilter({ list, id, val, propName }: any): string {
    const foundItem = list.find((x: FilterApi) =>
      x[id as keyof FilterApi].includes(val)
    );
    return foundItem ? foundItem[propName] : '';
  }

  async getAll(): Promise<DataApi[]> {
    const self = this;
    const paramsApi: any = {};

    for (const key in this.objectParam) {
      if (self.objectParam[key as keyof ParamsApi]) {
        paramsApi[key] = self.objectParam[key as keyof ParamsApi];
      }
    }

    self.loadingService.showLoading();

    return await fetchNDV({ body: { ...paramsApi } })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;

        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
        if (MENSAJE_RESPUESTA === 'SIN DATA') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
        return LISTA;
      })
      .catch((error: Error) => {
        //console.error(error.message);
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }

  async getFilters(): Promise<FilterApi> {
    const self: this = this;
    self.loadingService.showLoading();

    return await fetchNDV({ endpoint: 'get_filters' })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;

        if (CODIGO_RESPUESTA != '1' || MENSAJE_RESPUESTA === 'SIN DATA') {
          return self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        return LISTA;
      })
      .catch((error: Error) => {
        //console.error(error.message);
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => self.loadingService.hideLoading());
  }

  async add({ attention }: ParamsAttention): Promise<void> {
    const userId = getUserId();
    const user = localStorage.getItem('user');
    const rut = JSON.parse(user.replace(/'/g, '"')).rutClienteDefecto;
    this.loadingService.showLoading();
    const self = this;
    //console.log({ rut });

    return await fetchNDV({
      serviceClient: 'ltintegracion_inet',
      endpoint: 'crear_documento_comercial',
      body: {
        userId,
        rut,
        ...attention,
      },
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          return self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        return self.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
      })
      .catch((error: Error) => {
        //console.error(error.message);
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => self.loadingService.hideLoading());
  }
  beforeDestroy() {
    actionsEvent.removeListeners();
  }

  async getCSV(): Promise<void> {
    const userId = getUserId();
    const user = localStorage.getItem('clienteDefecto');

    const ndvcliente_razon = this.objectParam.ndvcliente_rut
      ? this.findFilter({
          list: this.filter.custumers,
          id: 'ndvcliente_rut',
          val: this.objectParam.ndvcliente_rut,
          propName: 'ndvcliente_razon',
        })
      : '';

    const estado = this.objectParam.ndvestado_conecta
      ? this.findFilter({
          list: this.filter.status,
          id: 'configid',
          val: this.objectParam.ndvestado_conecta,
          propName: 'configvalor',
        })
      : '';

    this.loadingService.showLoading();
    const self: this = this;

    return await fetchNDV({
      endpoint: 'export_excel',
      body: {
        userId,
        estado,
        user,
        ndvcliente_razon,
        ...self.objectParam,
      },
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          return self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        self.msgReport = MENSAJE_RESPUESTA;
        self.showPopUpReport = true;
      })
      .catch((error: Error) => {
        //console.error(error);
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }
}
